'use client'

import { Button } from "@/components/ui/button";
import ExclamationCircleIcon from "@heroicons/react/24/solid/ExclamationCircleIcon";
import { useEffect } from "react";

export default function Error({
  error,
  reset
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    void import("@/otel/browser-otel").then((m) => m.reportClientError(error));
  }, [error]);

  return (
    <html>
      <body>
        <div className="min-h-[400px] container flex flex-col items-center justify-center p-4 space-y-6">
          <ExclamationCircleIcon className="size-8 text-red-500" />

          <h1 className="text-2xl md:text-3xl font-bold text-gray-800 text-center">
            Bir Sorun Oluştu!
          </h1>

          <p className="text-gray-600 text-center max-w-md">
            Üzgünüz, bir hata ile karşılaştık. Lütfen daha sonra tekrar deneyiniz veya sayfayı yenileyiniz.
          </p>

          <div className="flex justify-center items-center max-md:flex-col gap-4 w-full">
            <Button
              className="max-md:w-full"
              variant="accent"
              onClick={() => window.location.href = '/'}
            >
              Ana Sayfa
            </Button>

            <Button
              className="max-md:w-full"
              variant="default"
              onClick={() => reset()}
            >
              Tekrar Dene
            </Button>
          </div>
        </div>
      </body>
    </html>
  )
}